import { useMemo } from 'react';
import { ProcedureTemplate, TemplateProcedureOverview } from '../../types/procedure';
import ProcedureCategorySection from './ProcedureCategorySection';
import { useIsActiveSubscription } from '../../hooks/use-is-active-subscription';

type ProceduresTableProps = {
    procedureTemplate: ProcedureTemplate;
    selectedProcedures: string[];
    onChecked: (procedure: TemplateProcedureOverview) => void;
};

function ProceduresTable({ procedureTemplate, selectedProcedures, onChecked }: ProceduresTableProps): JSX.Element {
    const activeSubscription = useIsActiveSubscription();

    const categoryGroups = useMemo(() => {
        const categoryGroups: { categoryId: string; categoryName: string; procedures: TemplateProcedureOverview[] }[] = [];
        const categories = procedureTemplate.categories;
        for (const category of categories) {
            const procedures = procedureTemplate.procedures.filter((p) => p.categoryId === category.id);
            categoryGroups.push({ categoryId: category.id, categoryName: category.name, procedures });
        }

        return categoryGroups;
    }, [procedureTemplate]);

    const otherProcedures = procedureTemplate.procedures.filter((p) => p.categoryId === undefined);
    const otherProceduresGroup = { categoryId: undefined, categoryName: 'Other', procedures: otherProcedures };

    function handleChecked(id: string): void {
        const selectedProcedure = procedureTemplate.procedures.filter((p) => p.id === id);
        onChecked(selectedProcedure[0]);
    }

    return (
        <div className="max-w-[100%] mx-auto">
            {procedureTemplate?.procedures.length === 0 && categoryGroups.length === 0 && (
                <p className="block text-center text-sm text-gray-500 pt-4">No procedures</p>
            )}

            {categoryGroups
                .sort((a, b) => (a.categoryName > b.categoryName ? 1 : -1))
                .map((cg, idx) => {
                    return (
                        <ProcedureCategorySection
                            key={idx}
                            templateId={procedureTemplate.id}
                            onChecked={handleChecked}
                            categoryDetails={cg}
                            isDisabled={!activeSubscription || procedureTemplate.system}
                            selectedProcedures={selectedProcedures}
                        />
                    );
                })}

            {otherProcedures.length > 0 && (
                <ProcedureCategorySection
                    templateId={procedureTemplate.id}
                    categoryDetails={otherProceduresGroup}
                    onChecked={handleChecked}
                    isDisabled={!activeSubscription || procedureTemplate.system}
                    selectedProcedures={selectedProcedures}
                />
            )}
        </div>
    );
}

export default ProceduresTable;
